import { setWith } from 'lodash';

// User
export const isLoggedIn = state =>
  state.user.username && state.user.username.length > 0;
export const user = state => state.user;

// App
export const isProcessing = state => state.app.isProcessing;
export const stompConfig = state => state.app.stompConfig;
export const stompConfigExists = state =>
  state.app.stompConfig.brokerUrl !== '';
export const gameState = state => state.app.gameState;
export const currentPoints = (state, getters) => {
  if (!getters.gameState.standings) return null;
  const standing = getters.gameState.standings.standings.find(
    ({ user }) => user.username === getters.user.username
  );
  if (!standing) return null;
  return standing.points;
};
export const activeGameId = state =>
  state.app.gameState.activeGame && +state.app.gameState.activeGame.id;
export const activeDuelId = state =>
  state.app.gameState.activeDuel && +state.app.gameState.activeDuel.id;
export const games = state => state.app.games;
export const stompState = state => state.app.stompState;
export const stompClient = (state, getters) => getters.stompState.client;
export const stompConnect = (state, getters) => getters.stompState.connect;
export const stompSubscriptions = (state, getters) =>
  getters.stompState.subscriptions;
export const connection = state => state.app.connection;
export const connectionModalInstance = state =>
  state.app.connectionModalInstance;

// Duel
export const predictionsTypes = state => state.app.predictionsTypes;
export const predictionsTypesParsed = (state, getters) => {
  if (!getters.predictionsTypes) return {};
  const result = {};
  Object.keys(getters.predictionsTypes).forEach((type, typeIndex) => {
    const typeParts = type.split('|');
    const itemParts = typeParts[typeParts.length - 1].split('@');
    const itemName = itemParts[0];
    const path = typeParts.reduce((acc, part, index) => {
      if (index + 1 !== typeParts.length) {
        return acc + part.split('@')[0] + '.';
      }
      return acc + `items[${part.split('@')[1] - 1}]`;
    }, '');
    setWith(result, path, {
      name: typeParts[typeParts.length - 1].split('@')[0],
      rate: getters.predictionsTypes[type],
      code: type,
    });
  });
  return result;
};
